import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction, httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload';
import { queryFactorList } from '@/api/api';
var paramColumns = [{
  title: '参数名称',
  dataIndex: 'name',
  align: 'center',
  width: '30%',
  scopedSlots: {
    customRender: 'name'
  }
}, {
  title: '参数值',
  dataIndex: 'remark',
  align: 'center',
  width: '40%',
  scopedSlots: {
    customRender: 'remark'
  }
}, {
  title: '单位',
  dataIndex: 'unit',
  align: 'center',
  width: '40%',
  scopedSlots: {
    customRender: 'unit'
  }
}, {
  title: '序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'sort'
  }
}, {
  title: '操作',
  align: 'center',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var partColumns = [{
  title: '配件类型',
  dataIndex: 'category',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'category'
  }
}, {
  title: '配件名称',
  dataIndex: 'name',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'name'
  }
}, {
  title: '配件说明',
  align: 'center',
  dataIndex: 'remark',
  width: '35%',
  scopedSlots: {
    customRender: 'remark'
  }
}, {
  title: '序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'sort'
  }
}, {
  title: '操作',
  dataIndex: 'operation2',
  align: 'center',
  scopedSlots: {
    customRender: 'operation2'
  }
}];
var stateColumns = [{
  title: '错误类别',
  dataIndex: 'category',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'category'
  }
}, {
  title: '错误码',
  dataIndex: 'code',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'code'
  }
}, {
  title: '名称',
  dataIndex: 'name',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'name'
  }
}, {
  title: '可能原因',
  dataIndex: 'causes',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'causes'
  }
}, {
  title: '解决方案',
  dataIndex: 'solution',
  align: 'center',
  width: '25%',
  scopedSlots: {
    customRender: 'solution'
  }
}, {
  title: '排序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'sort'
  }
}, {
  title: '操作',
  align: 'center',
  dataIndex: 'operation3',
  scopedSlots: {
    customRender: 'operation3'
  }
}];
var factorColumns = [{
  title: '监测因子',
  dataIndex: 'factorId',
  align: 'center',
  width: '25%',
  scopedSlots: {
    customRender: 'factorId'
  }
}, {
  title: '检出限',
  dataIndex: 'detection',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'detection'
  }
}, {
  title: '标准下限',
  dataIndex: 'lower',
  width: '15%',
  align: 'center',
  scopedSlots: {
    customRender: 'lower'
  }
}, {
  title: '标准上限',
  align: 'center',
  dataIndex: 'upper',
  width: '15%',
  scopedSlots: {
    customRender: 'upper'
  }
}, {
  title: '序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'sort'
  }
}, {
  title: '操作',
  align: 'center',
  width: '15%',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var productColumns = [{
  title: '产品名称',
  dataIndex: 'relatedId',
  align: 'center',
  width: '30%',
  scopedSlots: {
    customRender: 'relatedId'
  }
}, {
  title: '含量',
  dataIndex: 'dosage',
  align: 'center',
  width: '40%',
  scopedSlots: {
    customRender: 'dosage'
  }
}, {
  title: '序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'sort'
  }
}, {
  title: '操作',
  align: 'center',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var factorData = [];
var paramData = [];
var partData = [];
var productData = [];
var stateData = [];
var addParamDataIndex = 0;
var addPartDataIndex = 0;
var addFactorDataIndex = 0;
var addProductDataIndex = 0;
var addStateDataIndex = 0;
export default {
  name: 'ProductInfoModal',
  components: {
    IwsUpload: IwsUpload
  },
  mixins: [ModalFormMixin],
  data: function data() {
    this.cacheParamData = paramData.map(function (item) {
      return _objectSpread({}, item);
    });
    this.cachePartData = partData.map(function (item) {
      return _objectSpread({}, item);
    });
    this.cacheFactorData = factorData.map(function (item) {
      return _objectSpread({}, item);
    });
    this.cacheProductData = productData.map(function (item) {
      return _objectSpread({}, item);
    });
    this.cacheStateData = productData.map(function (item) {
      return _objectSpread({}, item);
    });
    return {
      title: '产品清单表单',
      tableName: 'ea_product_info',
      form_fields: ['companyId', 'code', 'name', 'category', 'unit', 'price', 'model', 'warranty', 'warn', 'summary', 'remark', 'photo', 'sort'],
      equipment_fields: ['repair', 'maintain', 'life', 'depreciation', 'residual', 'material', 'factorId'],
      chemical_fields: ['validity', 'danger', 'storage', 'quantity', 'type', 'quantityUnit', 'intensity', 'intensityUnit'],
      car_fields: ['type', 'maintain', 'driving', 'gearbox', 'weight', 'size', 'capacity', 'displacement', 'fuel'],
      instrument_fields: ['analysis', 'formula', 'pretreatment', 'calibration', 'verification', 'scope'],
      reference_fields: ['standard', 'factorId', 'refUnit'],
      form_fields_time: [],
      danger: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 10
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 14
        }
      },
      labelCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 3
        }
      },
      wrapperCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 15
        }
      },
      validatorRules: {
        code: {
          rules: [{
            required: true,
            message: '请输入产品编号!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入产品名称!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请输入产品类别!'
          }]
        },
        unit: {
          rules: [{
            required: true,
            message: '请输入计量单位!'
          }]
        },
        // quantity: { rules: [{ required: true, message: '请输入单位量!' }] },
        type: {
          rules: [{
            required: true,
            message: '请选择车辆类型!'
          }]
        },
        weight: {
          rules: [{
            required: true,
            message: '请选择车辆总质量!'
          }]
        },
        maintain: {
          rules: [{
            required: true,
            message: '请选择保养周期!'
          }]
        },
        driving: {
          rules: [{
            required: true,
            message: '请选择驱动形式!'
          }]
        },
        gearbox: {
          rules: [{
            required: true,
            message: '请选择变速箱型式!'
          }]
        },
        capacity: {
          rules: [{
            required: true,
            message: '请输入核定载客量!'
          }]
        },
        displacement: {
          rules: [{
            required: true,
            message: '请输入排气量!'
          }]
        },
        fuel: {
          rules: [{
            required: true,
            message: '请选择燃料种类!'
          }]
        },
        size: {
          rules: [{
            required: true,
            message: '请输入长宽高!'
          }]
        }
      },
      url: {
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['imgDomainURL'],
        carInfo: '/ea/product/car',
        chemicalInfo: '/ea/product/chemical',
        equipmentInfo: '/ea/product/equipment',
        instrumentInfo: '/ea/product/instrument',
        referenceInfo: '/ea/product/reference',
        productInfo: '/ea/product/info',
        queryCompany: '/ea/company/info/queryCompanyName'
      },
      paramColumns: paramColumns,
      partColumns: partColumns,
      factorColumns: factorColumns,
      stateColumns: stateColumns,
      productColumns: productColumns,
      factorData: factorData,
      paramData: paramData,
      partData: partData,
      productData: productData,
      stateData: stateData,
      addParamDataIndex: addParamDataIndex,
      addPartDataIndex: addPartDataIndex,
      addFactorDataIndex: addFactorDataIndex,
      addProductDataIndex: addProductDataIndex,
      addStateDataIndex: addStateDataIndex,
      tabsTitle: '配方成分',
      headers: {},
      picUrl: '',
      uploadLoading: false,
      category: '',
      companyList: [],
      infourl: '',
      factorOptions: [],
      factorOptions2: [],
      fields: [],
      productList: []
    };
  },
  props: ['pagePath'],
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token
    };
  },
  computed: {
    uploadAction: function uploadAction() {
      return this.url.fileUpload;
    }
  },
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      this.danger = false;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.loadCompany(); //厂商

      this.productList = [];
      this.loadProductList(); //产品列表

      this.model.category = this.category;
      this.partData = [];
      this.paramData = [];
      this.factorData = [];
      this.productData = [];
      this.stateData = []; //确定需要展示的属性以及后台请求路径

      this.fields = [];
      this.infourl = this.pagePath;

      if (this.category == 11) {
        this.loadFactor();
        this.loadFactor2();
        this.fields = this.form_fields.concat(this.equipment_fields);
        this.infourl = this.url.equipmentInfo;
      } else if (this.category == 12) {
        this.loadFactor();
        this.loadFactor2();
        this.infourl = this.url.instrumentInfo;
        this.fields = this.form_fields.concat(this.equipment_fields, this.instrument_fields);
      } else if (this.category == 21 || this.category == 22 || this.category == 23) {
        this.fields = this.form_fields.concat(this.chemical_fields);
        this.infourl = this.url.chemicalInfo;

        if (this.category == 23) {
          this.loadFactor();
          this.fields = this.fields.concat(this.reference_fields);
          this.infourl = this.url.referenceInfo;
        }
      } else if (this.category == 31) {
        this.fields = this.form_fields.concat(this.car_fields);
        this.infourl = this.url.carInfo;
      } else {
        this.fields = this.form_fields;
      }

      this.tabsTitle = this.category != 12 ? '配方成分' : '试剂标液';
      this.visible = true; //加载产品信息

      if (this.model.id || this.showTab == false) {
        this.loadProduct();
      } else if (!this.model.id) {
        this.renderProductModel();
      }
    },
    loadFactor: function loadFactor() {
      var _this = this;

      // 获取所有监测因子
      var paramsOne = {
        pageNo: 1,
        pageSize: 10000,
        status: 1
      };
      queryFactorList(paramsOne).then(function (res) {
        if (res.success) {
          _this.factorOptions = res.result.records;
        }
      });
    },
    loadFactor2: function loadFactor2() {
      var _this2 = this;

      // 获取状态因子
      var paramsOne = {
        pageNo: 1,
        pageSize: 10000,
        status: 1,
        category: 3
      };
      queryFactorList(paramsOne).then(function (res) {
        if (res.success) {
          _this2.factorOptions2 = res.result.records;
          console.log(_this2.factorOptions2);
        }
      });
    },
    loadProductList: function loadProductList() {
      var _this3 = this;

      var category = this.category == 12 ? 22 : this.category == 21 || this.category == 22 || this.category == 23 ? 21 : 0;
      var paramsOne = {
        pageNo: 1,
        pageSize: 10000,
        status: 1,
        category: category
      };
      getAction(this.url.productInfo, paramsOne).then(function (res) {
        if (res.success) {
          _this3.productList = [].concat(_toConsumableArray(_this3.productList), _toConsumableArray(res.result.records));
        }
      });

      if (this.category == 12) {
        var _paramsOne = {
          pageNo: 1,
          pageSize: 10000,
          status: 1,
          category: 23
        };
        getAction(this.url.productInfo, _paramsOne).then(function (res) {
          if (res.success) {
            _this3.productList = [].concat(_toConsumableArray(_this3.productList), _toConsumableArray(res.result.records));
          }
        });
      }
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    loadProduct: function loadProduct() {
      var _this4 = this;

      this.picUrl = '';
      getAction(this.infourl + '/' + this.model.id).then(function (res) {
        if (res.success) {
          _this4.model = Object.assign({}, res.result);
          _this4.picUrl = !_this4.model.photo ? '' : 'Has no pic url yet';

          _this4.renderProductModel();

          var paramList = [];

          for (var i = 0; i < _this4.model.params.length; i++) {
            var param = _this4.model.params[i];
            param.key = param.id;
            param.editable = !_this4.disableSubmit;
            paramList.push(param);
          }

          var partList = [];

          for (var _i = 0; _i < _this4.model.parts.length; _i++) {
            var part = _this4.model.parts[_i];
            part.key = part.id;
            part.editable = !_this4.disableSubmit;
            partList.push(part);
          }

          var stateList = [];

          for (var _i2 = 0; _i2 < _this4.model.states.length; _i2++) {
            var state = _this4.model.states[_i2];
            state.key = state.id;
            state.editable = !_this4.disableSubmit;
            stateList.push(state);
          }

          var productList = [];

          for (var _i3 = 0; _i3 < _this4.model.relateds.length; _i3++) {
            var related = _this4.model.relateds[_i3];
            related.key = related.id;
            productList.push(related);
          }

          var factorList = [];

          for (var _i4 = 0; _i4 < _this4.model.factors.length; _i4++) {
            var factor = _this4.model.factors[_i4];
            factor.key = factor.id;
            factorList.push(factor);
          }

          _this4.partData = partList;
          _this4.paramData = paramList;
          _this4.stateData = stateList;
          _this4.factorData = factorList;
          _this4.productData = productList;
        }
      });
    },
    renderProductModel: function renderProductModel() {
      var _this5 = this;

      this.$nextTick(function () {
        var that = _this5;
        that.form.setFieldsValue(pick(that.model, that.fields));
        that.danger = _this5.model.danger && _this5.model.danger == 1 ? true : false; //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);

        _this5.$refs.iwupload.loadUploadFiles();
      });
    },
    onDangerChange: function onDangerChange(e) {
      //console.log(this.danger)
      this.danger = e.target.checked;
      this.model.danger = e.target.checked == true ? 1 : 2;
    },
    handleOk: function handleOk() {
      var _this6 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });
          if (_this6.showTab == false) _this6.model.id = '';
          var httpurl = _this6.infourl,
              method = '';

          if (!_this6.model.id) {
            method = 'post';
          } else {
            method = 'put';
          }

          debugger;
          formData.params = _this6.paramData;
          formData.parts = _this6.partData;
          formData.factors = _this6.factorData;
          formData.relateds = _this6.productData;
          formData.states = _this6.stateData;
          var filelist = _this6.$refs.iwupload ? _this6.$refs.iwupload.getUploadList() : {
            fileDelList: [],
            sysFileList: []
          };
          formData.fileDelList = filelist.fileDelList;
          formData.sysFileList = filelist.sysFileList;
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    beforeUpload: function beforeUpload(file) {
      var fileType = file.type;

      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      } //TODO 验证文件大小

    },
    handleChange: function handleChange(info) {
      this.picUrl = '';

      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoading = false;

        if (response.success) {
          this.model.photo = response.result.id;
          this.picUrl = 'Has no pic url yet';
        } else {
          this.$notification.warning({
            message: response.message
          });
        }
      }
    },
    getAvatarView: function getAvatarView() {
      console.log(this.model.photo);
      return this.url.imgerver + '/' + this.model.photo;
    },
    // 技术参数表格相关的操作函数
    handleChangeTable1: function handleChangeTable1(value, key, column) {
      var newData = _toConsumableArray(this.paramData);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];
      console.log('target', target);

      if (target) {
        target[column] = value;
        this.paramData = newData;
      }
    },
    addTable1: function addTable1() {
      var newData = _toConsumableArray(this.paramData);

      newData.push({
        key: 'A1_' + this.addParamDataIndex,
        name: '',
        remark: '',
        sort: '',
        editable: true
      });
      this.addParamDataIndex = this.addParamDataIndex + 1;
      this.paramData = newData;
      this.cacheParamData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    delTable1: function delTable1(key) {
      var newData = this.paramData.filter(function (item) {
        return key != item.key;
      });
      this.paramData = newData;
      this.cacheParamData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    // 配料表格相关的操作函数
    handleChangeTable2: function handleChangeTable2(value, key, column) {
      var newData = _toConsumableArray(this.partData);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.partData = newData;
      }
    },
    addTable2: function addTable2() {
      var newData = _toConsumableArray(this.partData);

      newData.push({
        key: 'A2_' + this.addPartDataIndex,
        name: '',
        category: '',
        remark: '',
        sort: '',
        editable: true
      });
      this.addPartDataIndex = this.addPartDataIndex + 1;
      this.partData = newData;
      this.cachePartData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    delTable2: function delTable2(key) {
      var newData = this.partData.filter(function (item) {
        return key != item.key;
      });
      this.partData = newData;
      this.cachePartData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    // 站点因子
    addTable: function addTable() {
      var newData = _toConsumableArray(this.factorData);

      newData.push({
        key: 'A1_' + this.addFactorDataIndex,
        factorId: '',
        detection: '',
        lower: '',
        upper: '',
        sort: '',
        editable: true
      });
      this.addFactorDataIndex = this.addFactorDataIndex + 1;
      this.factorData = newData;
      this.cacheFactorData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    handleChangeFactorTable: function handleChangeFactorTable(value, key, column) {
      var newData = _toConsumableArray(this.factorData);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.factorData = newData;
      }
    },
    delFactorTable: function delFactorTable(key) {
      var newData = this.factorData.filter(function (item) {
        return key != item.key;
      });
      this.factorData = newData;
      this.cacheFactorData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    // 关联产品表格相关的操作函数
    handleChangeTable3: function handleChangeTable3(value, key, column) {
      var newData = _toConsumableArray(this.productData);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.productData = newData;
      }
    },
    addTable3: function addTable3() {
      var newData = _toConsumableArray(this.productData);

      newData.push({
        key: 'A1_' + this.addProductDataIndex,
        relatedId: '',
        dosage: '',
        sort: '',
        editable: true
      });
      this.addProductDataIndex = this.addProductDataIndex + 1;
      this.productData = newData;
      this.cacheProductData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    delTable3: function delTable3(key) {
      var newData = this.productData.filter(function (item) {
        return key != item.key;
      });
      this.productData = newData;
      this.cacheProductData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    // 产品状态码 表格相关的操作函数
    handleChangeTable4: function handleChangeTable4(value, key, column) {
      var newData = _toConsumableArray(this.stateData);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.stateData = newData;
      }
    },
    addTable4: function addTable4() {
      var newData = _toConsumableArray(this.stateData);

      newData.push({
        key: 'A4_' + this.addStateDataIndex,
        category: '',
        code: '',
        name: '',
        causes: '',
        solution: '',
        sort: '',
        editable: true
      });
      this.addStateDataIndex = this.addStateDataIndex + 1;
      this.stateData = newData;
      this.cacheStateData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    delTable4: function delTable4(key) {
      var newData = this.stateData.filter(function (item) {
        return key != item.key;
      });
      this.stateData = newData;
      this.cacheStateData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};